import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";

const RenelDoplerUltraSound = ({ ismodal, setIsmodal, data }) => {
  const practiseid = getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const age = dayjs().diff(dayjs(data?.dob), "year");
 const[isLoading,setIsLoading]=useState(false)
  const [providerList, setProviderList] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");

  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    reason:'',
    aortaVelocity: "",
    rtKidney: { L: "", W: "", H: "", arcuate: "", interlobular: "", segmental: "", mra_ri: "", rar: "" },
    ltKidney: { L: "", W: "", H: "", arcuate: "", interlobular: "", segmental: "", mra_ri: "", rar: "" },
    impression: "",
    signature: "",
  });

  useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);

  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange(null, "provider", data.linked_provider);
    } else if (providerList.length > 0) {
      handleChange(null, "provider", providerList[0].providername);
    }
  }
}, [providerList, data]);
  const handleChange = (section, field, value) => {
    if (section === "rtKidney" || section === "ltKidney") {
      setFormData((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    const errors = [];

    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.aortaVelocity.trim()) errors.push("Aorta Velocity is required.");
    if (!formData.rtKidney.L || !formData.rtKidney.W || !formData.rtKidney.H)
      errors.push("Right Kidney dimensions are required.");
    if (!formData.ltKidney.L || !formData.ltKidney.W || !formData.ltKidney.H)
      errors.push("Left Kidney dimensions are required.");
    // if (!formData.rtKidney.arcuate || !formData.rtKidney.interlobular || !formData.rtKidney.segmental || !formData.rtKidney.mra_ri || !formData.rtKidney.rar)
    //   errors.push("All Right Kidney Doppler fields are required.");
    // if (!formData.ltKidney.arcuate || !formData.ltKidney.interlobular || !formData.ltKidney.segmental || !formData.ltKidney.mra_ri || !formData.ltKidney.rar)
    //   errors.push("All Left Kidney Doppler fields are required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");

    return errors;
  };

  const handleSave = async() => {
    const errors = validateForm();

    console.log("Form Data Submitted:", formData);
    if (errors.length > 0) {
      console.warn("Validation Error:", errors);
      setToastMessage(errors[0]);
      setToastSeverity("error");
    } else {
     const selectedProvider = providerList.find(
        (p) => p.providername === formData.provider
      );

      const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
        providername: formData.provider,
        providerid: selectedProvider?.providerid,
        pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };
      let payload={...patientDetails,...formData}
try {
    setIsLoading(true)

     const user=await api.get('/auth/me')
          const [year, month, day] = formData.examDate.split("-");
          const formattedDate = `${month}/${day}/${year}`;
      
      const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
        "Worksheet_Type": "RENAL_DOPPLER_ULTRASOUND",
        "createdby": user?.username || '',
        "appurl": window.location.origin,
          // "appurl": "https://api.prd.brainymed.com",
        "Exam_Date": formattedDate,
        "data":payload
      });
      
      if(response.status==200){
        const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
        "filename": response?.data?.filename,      
        "worksheet_type":"RENAL_DOPPLER_ULTRASOUND",
         "appurl": window.location.origin,
          //  "appurl": "https://api.prd.brainymed.com",
        "exam_date": formattedDate
        })
        setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
          resetForm()
       setTimeout(() => {
    
        setIsmodal(false);
      }, 1000);
      
      }else{
        setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
      }
} catch (error) {
  console.log(error)
}finally{
setIsLoading(false)
}
    }

   
  };
const resetForm=()=>{
 setFormData({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    reason:'',
    aortaVelocity: "",
    rtKidney: { L: "", W: "", H: "", arcuate: "", interlobular: "", segmental: "", mra_ri: "", rar: "" },
    ltKidney: { L: "", W: "", H: "", arcuate: "", interlobular: "", segmental: "", mra_ri: "", rar: "" },
    impression: "",
    signature: "",
  })
}
  if (!ismodal) return null;


  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">RENAL DOPPLER ULTRASOUND</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={patientPhotoUrl(data.patientid)}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
            #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Date of Birth:</span> {formattedDOB}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Age:</span> {age} | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange(null, "provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.id} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input type="date" className="w-full border rounded px-2 py-1" value={formData.examDate} onChange={(e) => handleChange(null, "examDate", e.target.value)} />
          </div>
        </div>
 <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea placeholder="Enter Patient History here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.history} onChange={(e) => handleChange(null, "history", e.target.value)} />
        </div>
        <div className="mt-4">
          <label className="block text-sm font-medium">Reason For Procedure</label>
          <textarea placeholder="" value={formData.reason} onChange={(e) => handleChange(null, "reason", e.target.value)} className="w-full border rounded px-2 py-1 mt-1" rows={3}  />
        </div>

        <div className="mt-4">
          <h3 className="text-sm font-medium mb-2">Aorta Velocity</h3>
          <input
               type="number"
  step="0.01"
  inputMode="decimal"
            className="w-full border rounded px-2 py-1 mb-2"
            placeholder="Aorta Velocity"
            value={formData.aortaVelocity}
            onChange={(e) => handleChange(null, "aortaVelocity", e.target.value)}
          />
          <div className="grid grid-cols-3 gap-4 mb-2">
            <div>
              <label className="block text-xs font-medium">Right Kidney L</label>
              <input
            type="number"
  step="0.01"
  inputMode="decimal"
                className="w-full border rounded px-2 py-1"
                value={formData.rtKidney.L}
                onChange={(e) => handleChange("rtKidney", "L", e.target.value)}
              />
            </div>
            <div>
              <label className="block text-xs font-medium">Right Kidney W</label>
              <input
                type="number"
  step="0.01"
  inputMode="decimal"
                className="w-full border rounded px-2 py-1"
                value={formData.rtKidney.W}
                onChange={(e) => handleChange("rtKidney", "W", e.target.value)}
              />
            </div>
            <div>
              <label className="block text-xs font-medium">Right Kidney H</label>
              <input
          type="number"
  step="0.01"
  inputMode="decimal"
                className="w-full border rounded px-2 py-1"
                value={formData.rtKidney.H}
                onChange={(e) => handleChange("rtKidney", "H", e.target.value)}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-2">
            <div>
              <label className="block text-xs font-medium">Arcuate</label>
            <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.rtKidney.arcuate}
  onChange={(e) => handleChange("rtKidney", "arcuate", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">Interlobular</label>
             <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.rtKidney.interlobular}
  onChange={(e) => handleChange("rtKidney", "interlobular", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">Segmental</label>
           <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.rtKidney.segmental}
  onChange={(e) => handleChange("rtKidney", "segmental", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">MRA(RI/RAR)</label>
            
<input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.rtKidney.mra_ri}
  onChange={(e) => handleChange("rtKidney", "mra_ri", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">RAR</label>
             
<input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.rtKidney.rar}
  onChange={(e) => handleChange("rtKidney", "rar", e.target.value)}
/>
            </div>
          </div>

       
          <div className="grid grid-cols-3 gap-4 mb-2">
            <div>
              <label className="block text-xs font-medium">Left Kidney L</label>
              <input
                  type="number"
  step="0.01"
  inputMode="decimal"
                className="w-full border rounded px-2 py-1"
                value={formData.ltKidney.L}
                onChange={(e) => handleChange("ltKidney", "L", e.target.value)}
              />
            </div>
            <div>
              <label className="block text-xs font-medium">Left Kidney W</label>
              <input
             type="number"
  step="0.01"
  inputMode="decimal"
                className="w-full border rounded px-2 py-1"
                value={formData.ltKidney.W}
                onChange={(e) => handleChange("ltKidney", "W", e.target.value)}
              />
            </div>
            <div>
              <label className="block text-xs font-medium">Left Kidney H</label>
              <input
         type="number"
  step="0.01"
  inputMode="decimal"
                className="w-full border rounded px-2 py-1"
                value={formData.ltKidney.H}
                onChange={(e) => handleChange("ltKidney", "H", e.target.value)}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-2">
            <div>
              <label className="block text-xs font-medium">Arcuate</label>
            <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.ltKidney.arcuate}
  onChange={(e) => handleChange("ltKidney", "arcuate", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">Interlobular</label>
            <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.ltKidney.interlobular}
  onChange={(e) => handleChange("ltKidney", "interlobular", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">Segmental</label>
             <input
     type="number"
  step="0.01"
  inputMode="decimal"

  className="w-full border rounded px-2 py-1"
  value={formData.ltKidney.segmental}
  onChange={(e) => handleChange("ltKidney", "segmental", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">MRA(RI/RAR)</label>
            <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.ltKidney.mra_ri}
  onChange={(e) => handleChange("ltKidney", "mra_ri", e.target.value)}
/>
            </div>
            <div>
              <label className="block text-xs font-medium">RAR</label>
            <input
     type="number"
  step="0.01"
  inputMode="decimal"
  className="w-full border rounded px-2 py-1"
  value={formData.ltKidney.rar}
  onChange={(e) => handleChange("ltKidney", "rar", e.target.value)}
/>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Sonographer's Impression</label>
          <textarea placeholder="Enter Sonographer's Impression here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.impression} onChange={(e) => handleChange(null, "impression", e.target.value)} />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input className="w-full border rounded px-2 py-1 mt-1" placeholder="Signature" value={formData.signature} onChange={(e) => handleChange(null, "signature", e.target.value)} />
        </div>

        <div className="flex justify-end mt-6">
          <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Save</button>
        </div>
      </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={() => setOpenToast(false)} />
    </div>
  );
};

export default RenelDoplerUltraSound;